/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { update } from '../../services/item';
import { saveAll } from '../../store/items';
import { deepCloneArray } from '../../utils/array';
import { getId } from '../../utils/item';
import { InputTransparent } from '../form/input.Transparent';

export const DateGlobal = props => {
  const { itemId, dateId, date, canEdit = true } = props;

  // const items = useSelector(state => state.items);
  const item = useSelector(state => state.items[itemId]);
  const universe = useSelector(state => state.items[item?.universe]);
  const world = useSelector(state => state.items[item?.world]);
  const dispatch = useDispatch();

  const [calendars, setCalendars] = useState([]);

  const getItems = async itemId => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/items/${itemId}`
    );

    if (res.data?._id) {
      dispatch(saveAll({ item: res.data }));
    }
  };

  const updateField = async (field, value) => {
    if (!canEdit) {
      return;
    }
    const clonedDates = deepCloneArray(item.dates);
    const idx = clonedDates.findIndex(d => getId(d) === dateId);
    clonedDates[idx][dateId][field] = value;
    update(`items/${itemId}`, 'dates', clonedDates);
  };

  useEffect(() => {
    if (item?.universe && !universe) {
      getItems(item.universe);
    }
    if (item?.world && !world) {
      getItems(item.world);
    }
  }, [item]);

  useEffect(() => {
    if (universe?.calendars) {
      universe?.calendars.forEach(calendarU => {
        if (calendars.includes(calendarU)) {
          return;
        }
        setCalendars(prev => [...prev, calendarU]);
      });
    }
    if (world?.calendars) {
      world?.calendars.forEach(calendarW => {
        if (calendars.includes(calendarW)) {
          return;
        }
        setCalendars(prev => [...prev, calendarW]);
      });
    }
  }, [universe, world]);


  return (
    <>
      {canEdit ? (
        <InputTransparent
          className='bg-transparent h-auto border-0 px-0 py-0 m-0 text-center uppercase text-condensed text-xs text-contrast text-opacity-50'
          initValue={date.label}
          onBlur={value => updateField('label', value)}
        />
      ) : (
        <span className='uppercase text-condensed text-xs text-contrast text-opacity-50'>
          {date.label}
        </span>
      )}
      :{' '}
      {canEdit ? (
        <InputTransparent
          className='bg-transparent h-auto border-0 px-0 py-0 m-0 text-center uppercase text-condensed text-xs text-contrast text-opacity-50'
          initValue={date.date}
          onBlur={value => updateField('date', value)}
        />
      ) : (
        <span className='uppercase text-condensed text-xs text-contrast text-opacity-50'>
          {date.date}
        </span>
      )}
    </>
  );
};
